import _ from 'underscore';
import { helpers, DeterministicView } from '@bingads-webui/deterministic-view';
import template from './selector-template.pug';
import { Option } from './option';

const { updateView, ensureChildView } = helpers;

export class Selector extends DeterministicView {
  initialize({
    options = [],
    selectOption = {},
    nodataPlaceholder = '',
  }) {
    this.selectOption = selectOption;
    this.options = options;
    this.nodataPlaceholder = nodataPlaceholder;
  }

  get template() {
    return template;
  }

  getState() {
    const {
      options,
    } = this.model.attributes;

    return {
      options,
    };
  }

  setState({ options, selectOption }) {
    if (options) {
      this.selectOption = selectOption || this.selectOption;
      _.each(options, (option) => {
        const initialOption = this.selectOption.id === option.id ?
          { isSelected: true } :
          { isSelected: false };

        ensureChildView(this, `option-${option.id}`, Option, {}, {
          optionSelected: 'onOptionSelected',
        }).setState(_.extend(initialOption, option));
      });
      this.model.set({ options });
    }

    return this;
  }

  onOptionSelected({ id }) {
    if (this.selectOption && this.selectOption.id !== id) {
      const { options } = this.getState();

      this.selectOption = _.findWhere(options, { id });

      updateView(this, {
        options,
      });
    }
    this.trigger('optionSelected', this.selectOption);
  }
}
